import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_circle_marker = _resolveComponent("l-circle-marker")!
  const _component_l_feature_group = _resolveComponent("l-feature-group")!
  const _component_l_rectangle = _resolveComponent("l-rectangle")!

  return (_openBlock(), _createBlock(_component_l_feature_group, null, {
    default: _withCtx(() => [
      (_ctx.debug)
        ? (_openBlock(), _createBlock(_component_l_feature_group, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.debugPointsCoords, (coords) => {
                return (_openBlock(), _createBlock(_component_l_circle_marker, {
                  key: coords.lat * coords.lng,
                  "lat-lng": coords,
                  radius: 1,
                  color: "black",
                  opacity: 0.5
                }, null, 8, ["lat-lng"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.debug)
        ? (_openBlock(), _createBlock(_component_l_rectangle, {
            key: 1,
            color: "red",
            fill: false,
            weight: 2,
            bounds: _ctx.latLonBounds,
            interactive: false
          }, null, 8, ["bounds"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}